import { render } from "./OccupationCatalog.vue?vue&type=template&id=11232646&scoped=true"
import script from "./OccupationCatalog.vue?vue&type=script&lang=js"
export * from "./OccupationCatalog.vue?vue&type=script&lang=js"

import "./OccupationCatalog.vue?vue&type=style&index=0&id=11232646&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11232646"]])

export default __exports__